import React from "react";
import { Bike, CheckCircle2, Clock, Handshake, IndianRupee, PackageCheck, Send, Timer } from "lucide-react";
import { Card } from "./ui/card";
import {
  formatHours,
  formatMinutes,
  formatNumber,
  formatPct,
  formatRupees,
} from "./d2cFormat";

export const KpiCard = ({ label, value, note, icon: Icon, tone = "default" }) => (
  <Card className="tw-p-4">
    <div className="tw-flex tw-items-start tw-justify-between tw-gap-2">
      <span className="tw-text-xs tw-font-medium tw-text-muted-foreground">{label}</span>
      {Icon && (
        <span
          className={
            tone === "primary"
              ? "tw-flex tw-size-7 tw-items-center tw-justify-center tw-rounded-md tw-bg-accent tw-text-primary"
              : "tw-flex tw-size-7 tw-items-center tw-justify-center tw-rounded-md tw-bg-muted tw-text-muted-foreground"
          }
        >
          <Icon className="tw-size-4" aria-hidden="true" />
        </span>
      )}
    </div>
    <div className="tw-mt-1 tw-text-2xl tw-font-semibold tw-leading-8 tw-tracking-tight tw-text-foreground">{value}</div>
    {note && <div className="tw-mt-0.5 tw-text-xs tw-text-muted-foreground">{note}</div>}
  </Card>
);

const HeadlineTiles = ({ headline }) => {
  const h = headline || {};
  return (
    <div className="tw-grid tw-grid-cols-2 tw-gap-3 md:tw-grid-cols-4">
      <KpiCard label="Website bike orders" value={formatNumber(h.website_bike_orders)} icon={Bike} />
      <KpiCard label="Held for dealers" value={formatNumber(h.held)} icon={Handshake} />
      <KpiCard label="Offered" value={formatNumber(h.offered)} note={`${formatPct(h.offered_pct)} offered`} icon={Send} tone="primary" />
      <KpiCard
        label="Accepted"
        value={formatNumber(h.accepted)}
        note={`${formatPct(h.acceptance_rate)} acceptance`}
        icon={CheckCircle2}
        tone="primary"
      />
      <KpiCard
        label="Delivered"
        value={formatNumber(h.delivered)}
        note={`${formatPct(h.fulfilment_rate)} fulfilment`}
        icon={PackageCheck}
        tone="primary"
      />
      <KpiCard label="Median time to accept" value={formatMinutes(h.median_minutes_to_accept)} icon={Timer} />
      <KpiCard label="Median order to delivery" value={formatHours(h.median_hours_order_to_delivery)} icon={Clock} />
      <KpiCard
        label="Dealer fees due / raised"
        value={formatRupees(h.fees_due_amount)}
        note={`${formatRupees(h.fees_raised_amount)} raised`}
        icon={IndianRupee}
      />
    </div>
  );
};

export default HeadlineTiles;
